import {
    PERSON_RECEIVE,
    PERSON_ERROR,
    PERSON_CHANGE_MODE,
    ADDRESS_RECEIVE,
    ADDRESS_ERROR,
    ADDRESS_CHANGE_MODE,
    ORDER_RECEIVE,
    ORDER_ERROR,
    ORDER_CHANGE_MODE,
    ORDER_CHANGE_CURRENTPAGE,
    ORDER_SET_ORDER,
} from '../constants';
import {
    ADDRESS_DELETED,
    DOCUMENT_TYPES_RECEIVE,
    INVOICE_SET_INVOICE,
    INVOICE_ERROR,
    INVOICE_CHANGE_MODE,
    INVOICE_RECEIVE,
    INVOICE_CHANGE_CURRENTPAGE,
    PRELIMINARY_ORDER_RECEIVE,
    PRELIMINARY_ORDER_ERROR,
    PRELIMINARY_ORDER_CHANGE_MODE,
    PRELIMINARY_ORDER_CHANGE_CURRENTPAGE,
    PRELIMINARY_ORDER_SET_ORDER,
    QUOTE_RECEIVE,
    QUOTE_ERROR,
    QUOTE_CHANGE_MODE,
    QUOTE_CHANGE_CURRENTPAGE,
    QUOTE_SET_QUOTE,
    USER_RECEIVE,
    USER_ERROR,
    USER_GROSS_PRICE_TOGGLE,
    ADDRESS_CHANGE_CURRENTPAGE,
    SHOPPING_LIST_RECEIVE,
    SHOPPING_LIST_ERROR,
    SHOPPING_LIST_CHANGE_MODE,
    SHOPPING_LIST_CHANGE_CURRENTPAGE,
    SHOPPING_LIST_SET_SHOPPING_LIST,
} from '../bevegoConstants';
import { person as personReducer } from './Person.reducer';
import { address as addressReducer } from './Address.reducer';
import { order as orderReducer } from './Order.reducer';
import { quote as quoteReducer } from './Quote.reducer';
import { shoppingList as shoppingListReducer } from './ShoppingList.reducer';
import { preliminaryOrder as preliminaryOrderReducer } from './PreliminaryOrder.reducer';
import { invoice as invoiceReducer } from './Invoice.reducer';
import { user as userReducer } from './User.reducer';

const defaultState = {
    persons: {},
    addresses: {
        addressDeleted:''
    },
    orders: {
        currentPage: 1,
        documentTypes:[]
    },
    quotes: {
        currentPage: 1,
    },
    shoppingLists: {
        currentPage: 1,
    },
    preliminaryOrders: {
        currentPage: 1,
    },
    invoices: {
        fromDate: null,
        toDate: null,
    },
    
};

export const myPage = (state = defaultState, action) => {
    const { type, payload } = action;
    switch (type) {
        case PERSON_RECEIVE:
        case PERSON_ERROR:
        case PERSON_CHANGE_MODE:
            return {
                ...state,
                persons: personReducer(state.persons, action),
            };
        case ADDRESS_RECEIVE:
        case ADDRESS_ERROR:
        case ADDRESS_CHANGE_MODE:
        case ADDRESS_CHANGE_CURRENTPAGE:
        case ADDRESS_DELETED:
            return {
                ...state,
                addresses: addressReducer(state.addresses, action),
            };
        case ORDER_RECEIVE:
        case ORDER_ERROR:
        case ORDER_CHANGE_MODE:
        case ORDER_CHANGE_CURRENTPAGE:
        case ORDER_SET_ORDER:
        case DOCUMENT_TYPES_RECEIVE:
            return {
                ...state,
                orders: orderReducer(state.orders, action),
            };
        case QUOTE_RECEIVE:
        case QUOTE_ERROR:
        case QUOTE_CHANGE_MODE:
        case QUOTE_CHANGE_CURRENTPAGE:
        case QUOTE_SET_QUOTE:
            return {
                ...state,
                quotes: quoteReducer(state.quotes, action),
            };   
        case SHOPPING_LIST_RECEIVE:
        case SHOPPING_LIST_ERROR:
        case SHOPPING_LIST_CHANGE_MODE:
        case SHOPPING_LIST_CHANGE_CURRENTPAGE:
        case SHOPPING_LIST_SET_SHOPPING_LIST:
            return {
                ...state,
                shoppingLists: shoppingListReducer(state.shoppingLists, action),
            };   
        case PRELIMINARY_ORDER_RECEIVE:
        case PRELIMINARY_ORDER_ERROR:
        case PRELIMINARY_ORDER_CHANGE_MODE:
        case PRELIMINARY_ORDER_CHANGE_CURRENTPAGE:
        case PRELIMINARY_ORDER_SET_ORDER:
            return {
                ...state,
                preliminaryOrders: preliminaryOrderReducer(state.preliminaryOrders, action),
            };
        case INVOICE_SET_INVOICE:
        case INVOICE_ERROR:
        case INVOICE_CHANGE_MODE:
        case INVOICE_RECEIVE:
        case INVOICE_CHANGE_CURRENTPAGE:
            return {
                ...state,
                invoices: invoiceReducer(state.invoices, action),
            };
        case USER_RECEIVE:
        case USER_ERROR:
        case USER_GROSS_PRICE_TOGGLE:
            return {
                ...state,
                user: userReducer(state.user, action)
            };
        default:
            return state;
    }
};
